import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from "@ionic/angular";
import { JobFollowUpService } from 'src/app/shared/modals/job-follow-up/job-follow-up.service';
import { isEmpty, isNil } from "lodash";
import { JobStatus } from "src/app/shared/modals/job-follow-up/enums/job-status.enum";
import { filter, map } from 'rxjs/operators';
import { of } from "rxjs";

@Component({
    selector: 'app-job-follow-up',
    templateUrl: './job-follow-up.component.html',
    styleUrls: ['./job-follow-up.component.scss'],
})
export class JobFollowUpComponent implements OnInit {
    public JobStatus = JobStatus;
    @Input() public cycleId: number;
    @Input() public title: string = 'job.follow-up.title';
    @Input() public pageComponentName: string = "";

    public get jobs() {
        return this._jobFollowUpService.jobs$.pipe(
                map(jobs => jobs
                    .filter(job => job.cycleId === this.cycleId || job.pageComponentName === this.pageComponentName)
                    .sort((a, b) => Number(b.jobId) - Number(a.jobId)))
        );
    }

    constructor(private _jobFollowUpService: JobFollowUpService,
                private _modalController: ModalController
    ) {
    }

    ngOnInit() {
    }

    public save() {
        this.dismiss();
    }

    public clear() {

    }

    public close() {
        this.dismiss();
    }

    private dismiss() {
        this._modalController.dismiss();
    }


    public goToUrl(url: string) {
        if (isNil(url) || isEmpty(url)) return;
        window.open(url, '_blank');
    }
}
